import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import {
  exposeManualReset,
  runAuthStorageMigration,
} from './app/core/auth/auth-storage-migration';

// PBI-866415: purga tokens ADFS obsoletos ANTES de que la librería OIDC arranque.
runAuthStorageMigration();
exposeManualReset();

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
